import {createReducer} from 'redux-act';
import {
  CLEAR_FEEDBACK_DATA,
  CLEAR_FEEDBACK_REDESIGN_STATE,
  CLEAR_FEEDBACK_REVIEWS,
  GET_FEEDBACK_DATA_SUCCESS,
  GET_FEEDBACK_REVIEW_CONTEXT,
  GET_FEEDBACK_REVIEW_CONTEXT_FAILURE,
  GET_FEEDBACK_REVIEW_CONTEXT_SUCCESS,
  GET_FEEDBACK_REVIEWS,
  GET_FEEDBACK_REVIEWS_FAILURE,
  GET_FEEDBACK_REVIEWS_SUCCESS,
  GET_FEEDBACK_SUMMARY,
  GET_FEEDBACK_SUMMARY_FAILURE,
  GET_FEEDBACK_SUMMARY_SUCCESS,
  SEND_FEEDBACK_REPLY,
  SEND_FEEDBACK_REPLY_FAILURE,
  SEND_FEEDBACK_REPLY_SUCCESS,
  SET_FEEDBACK_CONTACT_STATUS,
  SET_FEEDBACK_CONTACT_STATUS_FAILURE,
  SET_FEEDBACK_CONTACT_STATUS_SUCCESS,
  GET_FEEDBACK_DISCOUNT,
  GET_FEEDBACK_DISCOUNT_SUCCESS,
  GET_FEEDBACK_DISCOUNT_FAILURE,
  CREATE_FEEDBACK_DISCOUNT,
  CREATE_FEEDBACK_DISCOUNT_SUCCESS,
  CREATE_FEEDBACK_DISCOUNT_FAILURE,
  UPDATE_FEEDBACK_DISCOUNT,
  UPDATE_FEEDBACK_DISCOUNT_SUCCESS,
  UPDATE_FEEDBACK_DISCOUNT_FAILURE,
  SET_FILTER,
  SET_LOADING
} from './action';

const initialFilters = () => ({
  startDate: null,
  endDate: null,
  datePickerSelectIndex: 0,
  tabIndex: 0
});

const initialRedesignState = () => ({
  summary: null,
  summaryLoading: false,
  reviews: [],
  reviewsLoading: false,
  reviewsTotalCount: 0,
  reviewsHasNextPage: false,
  reviewsPage: 0,
  contextById: {},
  contextLoadingById: {},
  contactStatusUpdatingById: {},
  replySendingById: {},
  replySentById: {},
  feedbackDiscount: null,
  feedbackDiscountLoading: false,
  feedbackDiscountSaving: false
});

const initialState = () => ({
  data: null,
  loading: false,
  filters: initialFilters(),
  redesign: initialRedesignState()
});

const feedbackReducer = createReducer(
  {
    [GET_FEEDBACK_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.data ? payload.data : {}
    }),
    [SET_LOADING]: (state, payload) => ({
      ...state,
      loading: payload
    }),
    [CLEAR_FEEDBACK_DATA]: () => ({
      ...initialState()
    }),
    [SET_FILTER]: (state, payload) => ({
      ...state,
      filters: {
        ...state.filters,
        ...payload
      }
    }),
    [CLEAR_FEEDBACK_REDESIGN_STATE]: (state) => ({
      ...state,
      redesign: initialRedesignState()
    }),
    [GET_FEEDBACK_SUMMARY]: (state) => ({
      ...state,
      redesign: {...state.redesign, summaryLoading: true}
    }),
    [GET_FEEDBACK_SUMMARY_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        summary: payload,
        summaryLoading: false
      }
    }),
    [GET_FEEDBACK_SUMMARY_FAILURE]: (state) => ({
      ...state,
      redesign: {...state.redesign, summaryLoading: false}
    }),
    [GET_FEEDBACK_REVIEWS]: (state) => ({
      ...state,
      redesign: {...state.redesign, reviewsLoading: true}
    }),
    [GET_FEEDBACK_REVIEWS_SUCCESS]: (state, payload) => {
      const append = !!payload.append;
      const incoming = payload.items || [];
      return {
        ...state,
        redesign: {
          ...state.redesign,
          reviews: append ? [...state.redesign.reviews, ...incoming] : incoming,
          reviewsTotalCount: payload.totalCount ?? incoming.length,
          reviewsHasNextPage: !!payload.hasNextPage,
          reviewsPage: payload.page ?? 0,
          reviewsLoading: false
        }
      };
    },
    [GET_FEEDBACK_REVIEWS_FAILURE]: (state) => ({
      ...state,
      redesign: {...state.redesign, reviewsLoading: false}
    }),
    [CLEAR_FEEDBACK_REVIEWS]: (state) => ({
      ...state,
      redesign: {
        ...state.redesign,
        reviews: [],
        reviewsTotalCount: 0,
        reviewsHasNextPage: false,
        reviewsPage: 0
      }
    }),
    [GET_FEEDBACK_REVIEW_CONTEXT]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        contextLoadingById: {
          ...state.redesign.contextLoadingById,
          [payload]: true
        }
      }
    }),
    [GET_FEEDBACK_REVIEW_CONTEXT_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        contextById: {
          ...state.redesign.contextById,
          [payload.id]: payload
        },
        contextLoadingById: {
          ...state.redesign.contextLoadingById,
          [payload.id]: false
        }
      }
    }),
    [GET_FEEDBACK_REVIEW_CONTEXT_FAILURE]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        contextLoadingById: {
          ...state.redesign.contextLoadingById,
          [payload.reviewId]: false
        }
      }
    }),
    [SET_FEEDBACK_CONTACT_STATUS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        contactStatusUpdatingById: {
          ...state.redesign.contactStatusUpdatingById,
          [payload.reviewId]: true
        }
      }
    }),
    [SET_FEEDBACK_CONTACT_STATUS_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        reviews: state.redesign.reviews.map((r) =>
          r.id === payload.reviewId
            ? {
                ...r,
                status: payload.status,
                contactedAt: payload.contactedAt,
                unread: false
              }
            : r
        ),
        contactStatusUpdatingById: {
          ...state.redesign.contactStatusUpdatingById,
          [payload.reviewId]: false
        }
      }
    }),
    [SET_FEEDBACK_CONTACT_STATUS_FAILURE]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        contactStatusUpdatingById: {
          ...state.redesign.contactStatusUpdatingById,
          [payload.reviewId]: false
        }
      }
    }),
    [GET_FEEDBACK_DISCOUNT]: (state) => ({
      ...state,
      redesign: {...state.redesign, feedbackDiscountLoading: true}
    }),
    [GET_FEEDBACK_DISCOUNT_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        feedbackDiscount: payload || null,
        feedbackDiscountLoading: false
      }
    }),
    [GET_FEEDBACK_DISCOUNT_FAILURE]: (state) => ({
      ...state,
      redesign: {...state.redesign, feedbackDiscountLoading: false}
    }),
    [CREATE_FEEDBACK_DISCOUNT]: (state) => ({
      ...state,
      redesign: {...state.redesign, feedbackDiscountSaving: true}
    }),
    [CREATE_FEEDBACK_DISCOUNT_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        feedbackDiscount: payload || state.redesign.feedbackDiscount,
        feedbackDiscountSaving: false
      }
    }),
    [CREATE_FEEDBACK_DISCOUNT_FAILURE]: (state) => ({
      ...state,
      redesign: {...state.redesign, feedbackDiscountSaving: false}
    }),
    [UPDATE_FEEDBACK_DISCOUNT]: (state) => ({
      ...state,
      redesign: {...state.redesign, feedbackDiscountSaving: true}
    }),
    [UPDATE_FEEDBACK_DISCOUNT_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        feedbackDiscount: payload || state.redesign.feedbackDiscount,
        feedbackDiscountSaving: false
      }
    }),
    [UPDATE_FEEDBACK_DISCOUNT_FAILURE]: (state) => ({
      ...state,
      redesign: {...state.redesign, feedbackDiscountSaving: false}
    }),
    [SEND_FEEDBACK_REPLY]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        replySendingById: {
          ...state.redesign.replySendingById,
          [payload.reviewId]: true
        }
      }
    }),
    [SEND_FEEDBACK_REPLY_SUCCESS]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        reviews: state.redesign.reviews.map((r) =>
          r.id === payload.reviewId
            ? {
                ...r,
                status: 'emailed',
                contactedAt: payload.sentAt,
                unread: false
              }
            : r
        ),
        replySendingById: {
          ...state.redesign.replySendingById,
          [payload.reviewId]: false
        },
        replySentById: {
          ...state.redesign.replySentById,
          [payload.reviewId]: {
            sentAt: payload.sentAt,
            customerEmail: payload.customerEmail
          }
        }
      }
    }),
    [SEND_FEEDBACK_REPLY_FAILURE]: (state, payload) => ({
      ...state,
      redesign: {
        ...state.redesign,
        replySendingById: {
          ...state.redesign.replySendingById,
          [payload.reviewId]: false
        }
      }
    })
  },
  initialState()
);

export default feedbackReducer;
